<template>
  <div class="index-left-menu" :style="IndexInfo.isOpenLeftMenu ? {} : { width: '40px' }">
    <!-- 左侧边栏图标  -->
    <div class="wrapper">
      <div class="left-menu-bar">
        <el-tooltip class="item" effect="dark" content="背景选择" placement="right">
          <div
            :class="current_left_nav_name === 'l-m-background' ? 'left-menu-item active' : 'left-menu-item'"
            @click="handleLeftNavTap('l-m-background')"
          >
            <div class="left-menu-item-btn el-icon-s-home"></div>
          </div>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="风格选择" placement="right">
          <div
            :class="current_left_nav_name === 'l-m-style' ? 'left-menu-item active' : 'left-menu-item'"
            @click="handleLeftNavTap('l-m-style')"
          >
            <div class="left-menu-item-btn el-icon-s-operation"></div>
          </div>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="添加图表" placement="right">
          <div
            :class="current_left_nav_name === 'l-m-charts' ? 'left-menu-item active' : 'left-menu-item'"
            @click="handleLeftNavTap('l-m-charts')"
          >
            <div class="left-menu-item-btn el-icon-s-data"></div>
          </div>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="添加场景" placement="right">
          <div
            :class="current_left_nav_name === 'l-m-scenery' ? 'left-menu-item active' : 'left-menu-item'"
            @click="handleLeftNavTap('l-m-scenery')"
          >
            <div class="left-menu-item-btn el-icon-picture"></div>
          </div>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="导入模板" placement="right">
          <div
            :class="current_left_nav_name === 'l-m-templates' ? 'left-menu-item active' : 'left-menu-item'"
            @click="handleLeftNavTap('l-m-templates')"
          >
            <div class="left-menu-item-btn el-icon-document-copy"></div>
          </div>
        </el-tooltip>
      </div>
      <div class="left-menu-box">
        <div class="wrapper">
          <component :is="current_left_nav_name"></component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapMutations } from 'vuex';
import LMStyle from '@/views/indexviews/left_menus/LMStyle.vue';
import LMCharts from '@/views/indexviews/left_menus/LMCharts.vue';
import LMBackground from '@/views/indexviews/left_menus/LMBackground.vue';
import LMScenery from '@/views/indexviews/left_menus/LMScenery.vue';
import LMTemplates from '@/views/indexviews/left_menus/LMTemplates.vue';
export default {
  name: 'IndexLeftMenu',
  components: {
    LMStyle,
    LMCharts,
    LMBackground,
    LMScenery,
    LMTemplates,
  },
  data() {
    return {
      current_left_nav_name: 'l-m-background', //此处有疑问 名称未对应
    };
  },
  computed: {
    ...mapState({
      ClientViewSize: state => state.ClientViewSize,
      IndexInfo: state => state.IndexInfo,
      ProjectInfo: state => state.ProjectInfo,
    }),
  },
  methods: {
    ...mapMutations(['set_IndexInfo']),

    handleLeftNavTap(name) {
      // 判断侧边 name 和 this.current_left_nav_name 一致 且 this.IndexInfo.isOpenLeftMenu 为 true
      if (this.current_left_nav_name === name && this.IndexInfo.isOpenLeftMenu === true) {
        // 设置当前编辑页面index页的左右菜单栏打开状态
        this.set_IndexInfo({
          isOpenLeftMenu: false,
        });
      } else {
        this.set_IndexInfo({
          isOpenLeftMenu: true,
        });
      }
      this.current_left_nav_name = name;
      console.log(this.current_left_nav_name, name, 'this.current_left_nav_name');
    },
  },
};
</script>
<style lang="scss" scoped>
.index-left-menu {
  width: 280px;
  height: 100%;
  transition: all 0.3s ease-out;
  overflow: hidden;
  .wrapper {
    width: 280px;
    height: 100%;
    display: flex;
    .left-menu-bar {
      width: 40px;
      height: 100%;
      flex-shrink: 0;
      background-color: $background-color-medium;
      box-sizing: border-box;
      border-right: 1px solid #000;
      .left-menu-item {
        outline: none;
        position: relative;
        width: 36px;
        height: 40px;
        padding-left: 3px;
        box-sizing: border-box;
        background-color: #00000000;
        transition: all 0.1s linear;
        color: $font-color-base;
        font-weight: 800;
        cursor: pointer;
        overflow: hidden;
      }
      .left-menu-item:hover::before {
        content: '';
        position: absolute;
        width: 3px;
        height: 100%;
        left: 0;
        top: 0;
        font-size: 12px;
        background: linear-gradient(180deg, #0225df, #ff42ca 59%, #fc1535);
      }
      .left-menu-item.active {
        background-color: #2d3053;
        color: #ffffff;
      }
      .left-menu-item.active::before {
        content: '';
        position: absolute;
        width: 3px;
        height: 100%;
        left: 0;
        top: 0;
        font-size: 12px;
        background: linear-gradient(180deg, #0225df, #ff42ca 59%, #fc1535);
      }
      .left-menu-item-btn {
        width: 100%;
        height: 100%;
        text-align: center;
        line-height: 40px;
        font-size: 20px;
      }
    }
    .left-menu-box {
      width: 240px;
      height: 100%;
      flex-shrink: 1;
      background-color: $background-color-light;
      overflow: hidden;
    }
  }
}
</style>
